const getUserEmail = async (sfid: string): Promise<{ email: string }> => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/users/email/${sfid}`);
    return await response.json();
};

export default getUserEmail;
